import { Helmet } from "react-helmet-async";

const SITE_NAME = "Eternal Biolabs";
const DEFAULT_DESCRIPTION = "Premium research-grade peptides in Canada. Third-party lab tested with transparent COAs. Simple checkout, pay by Interac e-Transfer.";

// Canonical host: collapse www/apex variants of the production domain onto the apex
export const siteOrigin = () => {
  const { protocol, host } = window.location;
  if (host === "eternalbiolabs.ca" || host.endsWith(".eternalbiolabs.ca")) return "https://eternalbiolabs.ca";
  return `${protocol}//${host}`;
};

export const Seo = ({ title, description = DEFAULT_DESCRIPTION, path = "", image, noindex = false, jsonLd, canonical }) => {
  const origin = siteOrigin();
  const url = `${origin}${path}`;
  const canonicalUrl = canonical || url;
  const absImage = image ? (image.startsWith("http") ? image : `${origin}${image}`) : `${origin}/eb-logo.png`;
  const fullTitle = title ? `${title} | ${SITE_NAME}` : `${SITE_NAME} | Research Peptides Canada — Lab Tested`;
  return (
    <Helmet>
      <title>{fullTitle}</title>
      <meta name="description" content={description} />
      <link rel="canonical" href={canonicalUrl} />
      {noindex && <meta name="robots" content="noindex, nofollow" />}
      <meta property="og:site_name" content={SITE_NAME} />
      <meta property="og:type" content="website" />
      <meta property="og:locale" content="en_CA" />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={url} />
      <meta property="og:image" content={absImage} />
      <meta name="twitter:card" content={image ? "summary_large_image" : "summary"} />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={absImage} />
      {jsonLd && <script type="application/ld+json">{JSON.stringify(jsonLd).replace(/</g, "\\u003c").replace(/>/g, "\\u003e").replace(/&/g, "\\u0026")}</script>}
    </Helmet>
  );
};
